import React from 'react';
import CustomerQueryList from '../../../id/common/customer/CustomerQueryList';
import PrimaryTab from './tabs/PrimaryTab';

// WM Query Transactions by Customer. The customer search panel + listing is the
// shared CustomerQueryList; this file only supplies the WM identity (title, grid
// and layout keys) and the WM detail screen.
const TransactionsByCustomerList = () => (
  <CustomerQueryList
    title="Enter Your Query For Customer"
    gridKey="B7F4C1E2-9A63-4D5E-8C10-2F7A6B34E9D1"
    layoutId="D3B8F1A6-2C47-4E59-9A81-5F60C7B2E4A3"
    layoutName="TransactionsByCustomerSearchForm"
    renderDetail={(rowId, onBack) => <PrimaryTab id={rowId} onBack={onBack} />}
  />
);

export default TransactionsByCustomerList;
